<template>

<div @click='likeDislike' class="like d-inline-block">
    <div class="d-flex align-items-center text-muted">
        <span v-if='!liked' class="d-flex align-items-center">
            <span class="icon icon-thumbs-up1 mr-1"></span>
            <span class="text">Like</span>
        </span>
        <span v-if='liked' class="d-flex align-items-center liked">
            <span class="icon icon-thumbs-up1 text-green mr-1"></span>
            <span class="text">Liked</span>
        </span>
        <span class="counter">{{ likes }}</span>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

            if( typeof this.r != 'undefined' && this.user ) {
                var reviewID = parseInt( this.r );
                
                if( this.user.rfavs.includes( reviewID ) ) {
                    this.liked = true;
                }

            }

            if( typeof this.l != 'undefined' ) {
                this.likes = parseInt( this.l );
            }

        },

        props : ['r','l'], 

        data() {

            return {
                
                disabled : false,
                liked    : false,
                likes    : 0,

            }

        },

        methods : {

            likeDislike : _.debounce( function() {
                if( !this.user ) {
                    location.href = '/login';
                }

                var me = this;

                if( me.liked ) {
                    var s = 0;
                } else {
                    var s = 1;
                }
            
                me.ajax.call('rvw:ldl', { r : this.r, s : s }, (r) => {

                    if( r.status == 'success' ) {

                        me.liked = !me.liked;
                        me.likes = r.data;

                    }

                });

            },150),

        }

    }
</script>
